import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { AUDIENCE_CARDS, DECO_COOKIE } from './salesData';

/** PARA QUIÉN ES. Cinco perfiles, del principiante al que ya vende. */
export function AudienceSection() {
  return <section className="relative overflow-hidden bg-ivory py-11 sm:py-16" aria-labelledby="audience-title" data-id="element-36" data-mp="x07erfj4978s">
      {/* Cookie decorativa que entra desde el lateral. */}
      <img src={DECO_COOKIE} alt="" aria-hidden loading="lazy" style={{
      ['--drift-rot' as string]: '-8deg'
    }} className="animate-drift pointer-events-none absolute -right-14 top-10 hidden h-36 w-36 rounded-full object-cover opacity-90 lg:block" data-id="element-37" data-mp="4aqr0v6fyeiw" />

      <div className="relative mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-38" data-mp="3cr3jma3qrk62">
        <div className="max-w-2xl" data-id="element-39" data-mp="3cozejou3wf47">
          <SectionTag data-id="element-40" data-mp="3hp4z6l1yl1cs">Para quién es</SectionTag>
          <h2 id="audience-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-41" data-mp="3ho26q8ozmqur">
            ¿Para quién es 100 New York Cookies?
          </h2>
        </div>

        <ul className="mt-7 grid gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-42" data-mp="ukr7dsghl7op">
          {AUDIENCE_CARDS.map((card, index) => <motion.li key={card.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(index, 4) * 0.035
        }} className="flex h-full flex-col rounded-4xl border border-warm bg-cream p-4 sm:p-5" data-id="element-43" data-mp="qimi15x2mx7v" data-mpi={index}>
              <span className="font-display text-[1.2rem] leading-none text-caramel" aria-hidden data-id="element-44" data-mp="260fzey8lkwwd">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="mt-2 font-display text-[1rem] leading-tight text-charcoal sm:text-[1.12rem]" data-id="element-45" data-mp="3vha08f1nlckm">
                {card.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.83rem] leading-snug text-charcoal-mid" data-id="element-46" data-mp="4470aj1zynmb">
                {card.body}
              </p>
            </motion.li>)}
        </ul>

        {/* Después del precio: ya puede ir directo al checkout. */}
        <CTAButton className="mt-7 w-full sm:w-auto" data-id="element-47" data-mp="i1vnhxjje6uj" />
      </div>
    </section>;
}